import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TicketService {

  constructor(private http: HttpClient) { }

  getOpenTickets(): Observable<any> {
    const url = `${environment.apiOrigin}/TicketService/api/tickets`;
    return this.http.get(url);
  }

  getTicket(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/TicketService/api/tickets/${id}`;

    return this.http.get(url);
  }

  updateCallerDetails(data: any): Observable<any> {
    const url = `${environment.apiOrigin}/TicketService/api/tickets/caller`;
    return this.http.post(url, data);
  }

  getTickets(userId: any): Observable<any> {
    const url = `${environment.apiOrigin}/TicketService/api/tickets/customer/${userId}`;
    return this.http.get(url);
  }

  savePhoneConversation(conversation: any): Observable<any> {
    const url = `${environment.apiOrigin}/TicketService/api/tickets/log/phone-conversation`;
    return this.http.post(url, conversation);
  }

  getTicketHistory(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/TicketService/api/tickets/history/${id}`;
    return this.http.get(url);
  }

  closeTicket(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/TicketService/api/tickets/close/${id}`;
    return this.http.post(url, {});
  }

  reOpenTicket(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/TicketService/api/tickets/re-open/${id}`;
    return this.http.post(url, {});
  }

  changeAssignment(assignment: any): Observable<any> {
    const url = `${environment.apiOrigin}/TicketService/api/tickets/change-assignment`;
    return this.http.post(url, assignment);
  }

  updateCustomer(ticketCustomerAssignment: any): Observable<any> {
    const url = `${environment.apiOrigin}/TicketService/api/tickets/update-customer`;
    return this.http.post(url, ticketCustomerAssignment);
  }

  sendEmail(emailDetails: any): Observable<any> {
    const url = `${environment.apiOrigin}/TicketService/api/tickets/send-email-response`;
    return this.http.post(url, emailDetails);
  }

  sendSms(mobileResponseDetails: any): Observable<any> {
    const url = `${environment.apiOrigin}/TicketService/api/tickets/send-sms-response`;
    return this.http.post(url, mobileResponseDetails);
  }

  saveInternalComment(internalComment: any): Observable<any> {
    const url = `${environment.apiOrigin}/TicketService/api/tickets/log/internal-comment`;
    return this.http.post(url, internalComment);
  }

  getMyOpenTickets(filterCriteria: any, limit: number): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/search-queries/${limit}`;
    return this.http.post(url, filterCriteria);
  }

  getCustomerTickets(userId: string): Observable<any> {
    const url = `${environment.apiOrigin}/TicketService/api/tickets/customer/${userId}`;
    return this.http.get(url);
  }
  getCityStateCountry(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/pin-code-details/${value}`;
    return this.http.get(url);
  }
  getAssignees(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/ticket-assignees`;
    return this.http.get(url);
  }

  getTicketDetails(id: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/ticket-details/${id}`;
    return this.http.get(url);
  }

  saveClassificationFollowup(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/ticket-classification-followup`;
    return this.http.post(url, value);
  }

  saveTicketAssignment(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/ticket-assignment`;
    return this.http.post(url, value);
  }

  callBack(id: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/call-back/${id}`;
    return this.http.get(url);
  }

  createNewTicket(mobileNumber: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/new-ticket/${mobileNumber}`;
    return this.http.put(url, {});
  }

  bulkChangeAssignment(ticketIdList: Array<string>, assignedTo: any): Observable<any> {
    const obj: any = {};
    obj.ticketIdList = ticketIdList;
    obj.assignedTo = assignedTo;
    const url = `${environment.apiOrigin}/api/customer-service/bulk-ticket-assignment`;
    return this.http.post(url, obj);
  }
}
